import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [

  //redirect empty path to home
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home'
  },
  {
    path: 'home',
    loadChildren: () => import('./landing/pages/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/pages/admin/admin.module').then(m => m.AdminModule)
  },
  {
    path: 'tentang-kami',
    loadChildren: () => import('./landing/pages/tentang-kami/tentang-kami.module').then(m => m.TentangKamiModule)
  },
  {
    path: 'panduan',
    loadChildren: () => import('./landing/pages/panduan/panduan.module').then(m => m.PanduanModule)
  },
  {
    path: 'list-tsp',
    loadChildren: () => import('./landing/pages/list-csr/list-csr.module').then(m => m.ListCsrModule)
  },
  {
    path: 'list-perusahaan',
    loadChildren: () => import('./landing/pages/list-perusahaan/list-perusahaan.module').then(m => m.ListPerusahaanModule)
  },
  {
    path: 'detail-tsp',
    loadChildren: () => import('./landing/pages/detail-csr/detail-csr.module').then(m => m.DetailCsrModule)
  },
  {
    path: 'detail-perusahaan',
    loadChildren: () => import('./landing/pages/detail-perusahaan/detail-perusahaan.module').then(m => m.DetailPerusahaanModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./admin/pages/auth/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'sign-up',
    loadChildren: () => import('./admin/pages/auth/sign-up/sign-up.module').then(m => m.SignUpModule)
  },
  {
    path: 'reset-password',
    loadChildren: () => import('./admin/pages/auth/reset-password/reset-password.module').then(m => m.ResetPasswordModule)
  },
  {
    path: 'restore-password',
    loadChildren: () => import('./admin/pages/auth/restore-password/restore-password.module').then(m => m.RestorePasswordModule)
  },
  {
    path: 'sign-up-mandiri',
    loadChildren: () => import('./admin/pages/auth/sign-up-mandiri/sign-up-mandiri.module').then(m => m.SignUpMandiriModule)
  },
  {
    path: 'coming-soon',
    loadChildren: () => import('./admin/pages/coming-soon/coming-soon.module').then(m => m.ComingSoonModule)
  },
  {
    path: 'submit-proposal-mandiri',
    loadChildren: () => import('./admin/pages/auth/submit-proposal-mandiri/submit-proposal-mandiri.module').then(m => m.SubmitProposalMandiriModule)
  },
  {
    path: 'pages/:slug',
    loadChildren: () => import('./landing/pages/blank-page/blank-page.module').then(m => m.BlankPageModule)
  },
  {
    path: 'error-404',
    loadChildren: () => import('./admin/pages/errors/error-not-found/error-not-found.module').then(m => m.ErrorNotFoundModule)
  },
  {
    path: 'error-500',
    loadChildren: () => import('./admin/pages/errors/error-internal-server-error/error-internal-server-error.module').then(m => m.ErrorInternalServerErrorModule)
  },
  {
    path: '**',
    loadChildren: () => import('./admin/pages/errors/error-not-found/error-not-found.module').then(m => m.ErrorNotFoundModule)
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
